import { motion, AnimatePresence } from 'framer-motion';
import { Heart, Skull, Crown } from 'lucide-react';
import { useSocketStore } from '../../stores/socketStore';
import { useAuthStore } from '../../stores/authStore';

export default function BattleRoyaleStatus() {
  const { playerLives, eliminatedPlayers, isEliminated, modeConfig, currentRoom } = useSocketStore();
  const { player } = useAuthStore();
  
  if (!modeConfig?.hasLives) return null;
  
  const myLives = player ? playerLives[player.id] || 0 : 0;
  const alivePlayers = currentRoom?.players.filter(p => !eliminatedPlayers.includes(p.id)) || [];
  
  return (
    <div className="mb-4">
      {/* Mes vies */}
      <motion.div 
        className={`card p-4 mb-4 ${isEliminated ? 'bg-red-900/30 border-red-500' : 'border-primary-500'}`}
        animate={isEliminated ? { opacity: [1, 0.5, 1] } : {}}
        transition={{ duration: 1, repeat: isEliminated ? Infinity : 0 }}
      >
        {isEliminated ? (
          <div className="flex items-center justify-center gap-3 text-red-400">
            <Skull className="w-8 h-8" />
            <span className="text-xl font-bold">Éliminé !</span>
            <Skull className="w-8 h-8" />
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2">
            <span className="text-dark-300 mr-2">Vos vies:</span>
            {Array.from({ length: modeConfig.livesCount }).map((_, i) => (
              <motion.div
                key={i}
                initial={{ scale: 1 }}
                animate={i >= myLives ? { scale: 0.8, opacity: 0.3 } : { scale: [1, 1.2, 1] }}
                transition={i < myLives ? { duration: 0.5, repeat: Infinity, repeatDelay: 1 } : {}}
              >
                <Heart 
                  className={`w-8 h-8 ${i < myLives ? 'text-red-500 fill-red-500' : 'text-gray-600'}`}
                />
              </motion.div>
            ))}
          </div>
        )}
      </motion.div>
      
      {/* Joueurs en vie */}
      <div className="flex flex-wrap items-center justify-center gap-2 text-sm">
        <span className="text-dark-400">
          <Crown className="w-4 h-4 inline mr-1" />
          {alivePlayers.length} joueur{alivePlayers.length > 1 ? 's' : ''} en vie:
        </span>
        {alivePlayers.map((p, i) => (
          <span key={p.id} className="text-white">
            {p.name}{i < alivePlayers.length - 1 ? ',' : ''}
          </span>
        ))}
      </div>
      
      {/* Joueurs éliminés */}
      <AnimatePresence>
        {eliminatedPlayers.length > 0 && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            className="mt-2 text-center text-dark-500 text-xs"
          >
            <Skull className="w-3 h-3 inline mr-1" />
            Éliminés: {currentRoom?.players
              .filter(p => eliminatedPlayers.includes(p.id))
              .map(p => p.name)
              .join(', ')}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
